<template>
  <div class="trustpilot-review">
    <img
      src="/logos/trustpilot_logo_black.svg"
      height="75"
      width="300"
      alt="trustpilot"
      class="trustpilot-review__image"
      loading="eager"
    />
    <span class="vr trustpilot-review__divider" />
    <span
      class="trustpilot-review__text"
      v-html="$t('trustpilot_review_text')"
    />
  </div>
</template>

<script setup>
  const { t: $t } = useI18n()
</script>

<style lang="scss">
  .trustpilot-review {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #191919;

    @include breakpoint(desktop) {
      gap: 16px;
    }
  }

  .trustpilot-review__image {
    height: 27px;
    width: auto;
    object-fit: contain;
    margin: 0 0 6px;
  }

  .trustpilot-review__divider {
    height: 33px;
  }

  .trustpilot-review__text {
    font-weight: 300;
    font-size: 13px;

    @include breakpoint(desktop) {
      font-size: 15px;
    }
  }
</style>
